import React, { Component } from 'react';

import ReactGA from 'react-ga';
import * as GoogleAnalyticsConfig from './config/ga';

import './App.css';

import { Parse } from 'parse';
import * as ParseConfig from './config/parse';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import AppBar from 'material-ui/AppBar';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

import * as Colors from './styles/colors';

import SignIn from './scenes/Authentication/components/SignIn';
import NavigationDrawer from './NavigationDrawer';
import ParseAvatar from './components/ParseAvatar';

import AssignmentSceneCoordinator from './AssignmentSceneCoordinator';
import PlannerSceneCoordinator from './PlannerSceneCoordinator';
import OrganizerSceneCoordinator from './OrganizerSceneCoordinator';
import AccountDetail from './scenes/Account/components/AccountDetail';
import ErrorDialog from './components/ErrorDialog';
//import SettingsSceneCoordinator from './SettingsSceneCoordinator';

ReactGA.initialize(GoogleAnalyticsConfig.propertyID);

Parse.initialize(ParseConfig.appID);
Parse.serverURL = ParseConfig.serverURL;

const hwTheme = getMuiTheme({
  palette: {
    primary1Color: Colors.alizarin,
    accent1Color: Colors.peterRiver,
    textColor: Colors.textColor,
    secondaryTextColor: Colors.secondaryTextColor,
  },
  // appBar: {
  //   height: 56,
  // },
  checkbox: {
    checkedColor: Colors.emerald,
    requiredColor: Colors.emerald,
  },
  menuItem: {
    height: 52,
  },
  icon: {
    color: Colors.peterRiver,
  },
});

function AppBarTitle(props) {
  const index = props.sceneIndex;
  var title = "";

  switch(index) {
    case 1:
      title = "Planner";
      break;
    case 2:
      title = "Organizer";
      break;
    default:
      title = "Assignments";
      break;
  }

  return title;
}

function Scene(props) {
  var scene = null;
  
  switch(props.sceneIndex) {
    case 0:
      scene = <AssignmentSceneCoordinator />
      break;
    case 1:
      scene = <PlannerSceneCoordinator />
      break;
    case 2:
      scene = <OrganizerSceneCoordinator />
      break;
    default:
      scene = null;
  }

  return scene;
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentScene: 0,
      isSignedIn: false,
      isDrawerOpen: false,
      isShowingAccount: false,
      isShowingSettings: false,
      signInError: null,
    };

    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.handleSceneChange = this.handleSceneChange.bind(this);
    this.handleToggleDrawer = this.handleToggleDrawer.bind(this);
    this.handleDrawerRequestChange = this.handleDrawerRequestChange.bind(this);
    this.handleAccountDetailClose = this.handleAccountDetailClose.bind(this);
    this.handleDetailSceneChange = this.handleDetailSceneChange.bind(this);
  }

  handleSignIn(email, password) {
    const that = this;
    console.log("Signing in...");
    
    Parse.User.logIn(email, password).then(function() {
      that.setState({isSignedIn: true});
    }, function(err) {
      that.setState({signInError: err.message})
    });
  }

  handleAccountDetailClose() {
    this.setState({isShowingAccount: false});
  }

  handleSceneChange(index) {
    this.setState({currentScene: index});
  }

  handleSignOut(e) {
    const that = this;
    
    Parse.User.logOut().then(function() {
      that.setState({isSignedIn: false});
    }, function(err) {
      console.log("Failed to sign out " + err)
    });
  }

  handleToggleDrawer(e) {
    this.setState({isDrawerOpen: !this.state.isDrawerOpen});
  }

  handleDrawerRequestChange(open) {
    this.setState({isDrawerOpen: open});
  }

  handleDetailSceneChange(index) {
    if (index === 0) {
      this.setState({isShowingAccount: !this.state.isShowingAccount, 
                     isShowingSettings: false,
                     isDrawerOpen: false,
                   });
    } else {

    }
  }

  componentWillMount() {
    const isSignedIn = Parse.User.current() != null;
    this.setState({isSignedIn: isSignedIn});
  }

  render() {
    const isSignedIn = this.state.isSignedIn;

    const sceneTitle = <AppBarTitle sceneIndex={this.state.currentScene} />
    const sceneContent = <Scene sceneIndex={this.state.currentScene} />
    
    var detailSceneContent = null;
    if (this.state.isShowingAccount) {
      detailSceneContent = <AccountDetail
                              user={Parse.User.current()}
                              onAccountDetailClose={this.handleAccountDetailClose}
                            />
    }

    return (
      <MuiThemeProvider muiTheme={hwTheme}>
        <div>
          { isSignedIn ? (
            <AppBar
              title={ isSignedIn ? sceneTitle : "iHomework" }
              showMenuIconButton={isSignedIn}
              iconElementRight={isSignedIn ? (
                  <IconMenu
                    desktop={true}
                    anchorOrigin={ {horizontal: "right", vertical: "bottom"} }
                    targetOrigin={ {horizontal: "right", vertical: "top"} }
                    iconButtonElement={(
                      <div style={{cursor: "pointer", "paddingTop": "5px"}}>
                        <ParseAvatar file={Parse.User.current().get('avatarData')} size={36} />
                      </div>
                    )}>
                      <MenuItem primaryText="My Account" onClick={() => this.handleDetailSceneChange(0)} />
                      <MenuItem primaryText="Sign Out" onClick={this.handleSignOut} />
                  </IconMenu>
                )
                : (
                  null
                )
              }
              onLeftIconButtonTouchTap={isSignedIn ? this.handleToggleDrawer : null}
            />
          ) : null }
        </div>

        <div className="App">
          {isSignedIn ? (
            <div className="App-container">
              <NavigationDrawer 
                isOpen={this.state.isDrawerOpen} 
                onRequestChange={this.handleDrawerRequestChange}
                onSceneChange={this.handleSceneChange}
                onDetailSceneChange={this.handleDetailSceneChange}
                selectedScene={this.state.currentScene} />
              { sceneContent }
              { detailSceneContent }
            </div>
          ) : (
            <SignIn onSignIn={this.handleSignIn}  />
          )}

          { this.state.signInError != null ? (
            <ErrorDialog 
              title="Sign In Error"
              message={this.state.signInError} 
              onClose={() => this.setState({signInError: null})} />
          ) : null}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js